import React, { useEffect, useState } from "react";
import "survey-core/defaultV2.css";
import * as Survey from "survey-react-ui";
import { Model } from "survey-core";
import { Card, Typography, Row, Col, Spin, message } from "antd";
import dataService from "../networks/api/service/dataService";
import { useParams } from "react-router-dom";

const { Title } = Typography;

const SurveyFormData = () => {
  const { id } = useParams();
  const [surveyModel, setSurveyModel] = useState(null);
  const [loading, setLoading] = useState(false);

  const convertResponseToForm = (response) => {
    const pages = [];
    for (let i = 0; i < response.question.length; i += 5) {
      const elements = response.question.slice(i, i + 5).map((q, index) => {
        let element = {
          name: q._id,
          title: q.question,
          isRequired: true,
        };

        switch (q.type) {
          case "text":
            element.type = "text";
            element.validators = [
              {
                type: "regex",
                text: "Only letters are allowed",
                regex: "^[A-Za-z ]+$", // Allows only letters and spaces
              },
            ];
            break;

          case "email":
            element.type = "text";
            element.inputType = "email"; // Ensures email input
            element.validators = [
              {
                type: "email",
                text: "Please enter a valid email address",
              },
              {
                type: "regex",
                text: "Email must contain '@' symbol",
                regex: "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$", // Enforces email format
              },
            ];
            break;

          case "number":
            element.type = "text";
            element.inputType = "number"; // Sets the input type to number
            element.validators = [
              {
                type: "regex",
                text: "Only numbers are allowed",
                regex: "^[0-9]+$", // Allows only numbers
              },
            ];
            break;

          case "radio":
            element.type = "radiogroup";
            element.choices = q.options;
            break;

          case "rating":
            element.type = "rating";
            break;

          case "comment":
            element.type = "comment";
            break;

          default:
            element.type = "text";
        }
        return element;
      });

      pages.push({ elements });
    }

    return {
      id: response._id,
      title: response.title,
      showProgressBar: "top",
      pages,
    };
  };

  // Fetch form data from API
  const getFormData = async (id) => {
    setLoading(true);
    console.log(id, "idid");
    try {
      const response = await dataService.getFormFromId(id);
      setLoading(false);
      if (response.code === 200) {
        const surveyData = convertResponseToForm(response.data);
        setSurveyModel(new Model(surveyData));
      } else {
        message.error("Something went wrong");
      }
    } catch (e) {
      setLoading(false);
      message.error("Error fetching survey data");
    }
  };

  useEffect(() => {
    getFormData(id);
  }, []);

  // Handle survey completion
  const handleSurveyComplete = (sender) => {
    const resultData = sender.data;

    // Extract full question data (including options and questionId)
    const fullResults = sender.getAllQuestions().map((question) => ({
      questionId: question.name, // The name is set to questionId in convertResponseToForm
      question: question.title,
      type: question.getType(),
      answer: resultData[question.name],
      options: question.choices
        ? question.choices.map((choice) => choice.value)
        : null,
    }));

    submitFormData(fullResults);
  };

  const submitFormData = async (data) => {
    try {
      const emailData = data.find((item) => item.question === "email")?.answer;
      const payload = {
        email: emailData,
        answers: data,
      };
      const res = await dataService.submitSurveyData(id, payload);
      if (res.code === 200) {
        message.success("Form submitted successfully");
      }
    } catch (e) {}
  };
  if (loading) return <Spin size="large" />;

  return (
    <Row justify="center" style={{ padding: "2rem", background: "lightgrey" }}>
      <Col xs={24} sm={20} md={16} lg={12}>
        <Card
          style={{
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "2rem",
          }}
        >
          <Title level={3} style={{ textAlign: "center", color: "#1890ff" }}>
            Survey Form
          </Title>

          {surveyModel && (
            <Survey.Survey
              model={surveyModel}
              onComplete={handleSurveyComplete}
            />
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default SurveyFormData;
